import { useTranslation } from 'react-i18next'

const buttons = [
  {
    name: 'Arch Linux',
    src: '/buttons/archlinux.gif',
    fallbackSrc: 'https://88x31.nl/gifs/archlinux.gif',
    href: 'https://archlinux.org',
  },
  {
    name: 'Debian',
    src: '/buttons/debian.gif',
    fallbackSrc: 'https://skye.sh/media/content/88x31/debian.gif',
    href: 'https://www.debian.org',
  },
  {
    name: 'Linux Powered',
    src: '/buttons/linux-p.gif',
    fallbackSrc: 'https://88x31.nl/gifs/linux-p.gif',
    href: 'https://kernel.org',
  },
  {
    name: 'Zed Editor',
    src: '/buttons/zed.gif',
    fallbackSrc: '/buttons/zed.gif',
    href: 'https://zed.dev',
  },
  {
    name: 'Vim',
    src: '/buttons/vim.gif',
    fallbackSrc: 'https://www.vim.org',
    href: 'https://www.vim.org',
  },
  {
    name: 'Visual Studio Code',
    src: '/buttons/vscode.gif',
    fallbackSrc: 'https://code.visualstudio.com',
    href: 'https://code.visualstudio.com',
  },
  {
    name: 'DOOM',
    src: '/buttons/doom.gif',
    fallbackSrc: 'http://www.deadnet.se/88x31/doom.gif',
    href: 'https://en.wikipedia.org/wiki/Doom_(1993_video_game)',
  },
  {
    name: '7-Zip',
    src: '/buttons/7zip.gif',
    fallbackSrc: 'https://88x31.nl/gifs/7zip.gif',
    href: 'https://www.7-zip.org',
  },
  {
    name: 'CodeBrain',
    src: '/buttons/codebrain.gif',
    fallbackSrc: 'https://cyber.dabamos.de/88x31/codebrain.gif',
    href: 'https://github.com/Sqrilizz',
  },
  {
    name: 'Coke',
    src: '/buttons/coke.gif',
    fallbackSrc: 'https://cyber.dabamos.de/88x31/coke.gif',
    href: 'https://cyber.dabamos.de/88x31/',
  },
  {
    name: 'Coffee',
    src: '/buttons/coffee.gif',
    fallbackSrc: 'https://cyber.dabamos.de/88x31/coffee.gif',
    href: 'https://en.wikipedia.org/wiki/Coffee',
  },
  {
    name: 'Piracy',
    src: '/buttons/piracy.gif',
    fallbackSrc: 'https://raw.githubusercontent.com/HazyGravy/88x31_web_buttons/main/88x31/piracy.gif',
    href: 'https://en.wikipedia.org/wiki/Warez',
  },
  {
    name: 'No Cookies',
    src: '/buttons/nocookie.gif',
    fallbackSrc: 'https://raw.githubusercontent.com/HazyGravy/88x31_web_buttons/main/88x31/nocookie.gif',
    href: 'https://sqrilizz.tech',
  },
  {
    name: 'Dark Mode',
    src: '/buttons/dark-mode.gif',
    fallbackSrc: 'https://cyber.dabamos.de/88x31/dark-mode.gif',
    href: 'https://sqrilizz.tech',
  },
  {
    name: 'ASCII Cat',
    src: '/buttons/asciicat.gif',
    fallbackSrc: 'https://cyber.dabamos.de/88x31/asciicat.gif',
    href: 'https://en.wikipedia.org/wiki/ASCII_art',
  },
  {
    name: 'Neocities',
    src: '/buttons/button38.gif',
    fallbackSrc: 'https://yesterhost.neocities.org/archive/buttons/button38.gif',
    href: 'https://neocities.org',
  },
]

export default function Footer() {
  const { i18n } = useTranslation()
  const isRu = i18n.language === 'ru'

  return (
    <footer className="border-t border-zinc-900 py-10 px-6">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-6">
        {/* 88x31 Retro Web Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2.5">
          {buttons.map((b) => (
            <a
              key={b.name}
              href={b.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition-transform hover:-translate-y-0.5 active:scale-95"
              title={b.name}
            >
              <img
                src={b.src}
                alt={b.name}
                width="88"
                height="31"
                loading="lazy"
                decoding="async"
                className="w-[88px] h-[31px] rounded-[2px] [image-rendering:pixelated] border border-zinc-800/80 shadow-sm hover:border-zinc-700"
                onError={(e) => {
                  if (e.currentTarget.src !== b.fallbackSrc) {
                    e.currentTarget.src = b.fallbackSrc
                  }
                }}
              />
            </a>
          ))}
        </div>

        {/* Bottom copyright & language switcher */}
        <div className="w-full flex items-center justify-between border-t border-zinc-900/80 pt-6">
          <span className="text-sm text-zinc-600 font-mono">
            sqrilizz · {new Date().getFullYear()}
          </span>
          <button
            onClick={() => i18n.changeLanguage(isRu ? 'en' : 'ru')}
            aria-label={isRu ? 'Switch language to English' : 'Переключить язык на русский'}
            className="text-xs text-zinc-500 hover:text-zinc-200 transition-colors font-mono px-2.5 py-1 rounded-md bg-zinc-900/60 border border-zinc-800/70 hover:bg-zinc-800/60"
          >
            {isRu ? 'EN' : 'RU'}
          </button>
        </div>
      </div>
    </footer>
  )
}
